import sendRequest from "./send-request";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// One service for all the small tag collections. Names keep the casing as
// typed; the backend dedupes them case-insensitively.
export const TAG_TYPES = {
  theme: { path: "themes", nameField: "themeName", label: "Theme" },
  colour: { path: "colours", nameField: "colourName", label: "Colour" },
  category: { path: "categories", nameField: "categoryName", label: "Category" },
  series: { path: "series", nameField: "seriesName", label: "Series" },
  designer: { path: "designers", nameField: "designerName", label: "Designer" },
  printingProcess: {
    path: "printing-processes",
    nameField: "printingProcessName",
    label: "Printing process",
  },
};

function cleanName(name) {
  return name.trim();
}

// Like the themes/colours services, these return the Error on failure
// (callers check for ._id / .status) instead of throwing
export async function getTags(type) {
  try {
    return await sendRequest(`${BASE_URL}/${TAG_TYPES[type].path}`, "GET");
  } catch (err) {
    return err;
  }
}

export async function createTag(type, name) {
  const { path, nameField } = TAG_TYPES[type];
  try {
    return await sendRequest(`${BASE_URL}/${path}`, "POST", {
      [nameField]: cleanName(name),
    });
  } catch (err) {
    return err;
  }
}

export async function updateTag(type, id, name) {
  const { path, nameField } = TAG_TYPES[type];
  try {
    return await sendRequest(`${BASE_URL}/${path}/${id}`, "PUT", {
      [nameField]: cleanName(name),
    });
  } catch (err) {
    return err;
  }
}

export async function deleteTag(type, id) {
  try {
    return await sendRequest(
      `${BASE_URL}/${TAG_TYPES[type].path}/${id}`,
      "DELETE",
    );
  } catch (err) {
    return err;
  }
}
